module.exports = __webpack_public_path__ + "static/img/biaoti-01.0d9c8f86.png";